import React from "react";
import { ReactLenis } from "lenis/react";

export default function SmoothScroll({ children }) {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, duration: 1.1 }}>
      {children}
    </ReactLenis>
  );
}
